/* eslint-disable no-confusing-arrow,implicit-arrow-linebreak */
import {
  HockeySports, SoccerSports, Sport, LacrosseSports,
} from '../enums/exchange';

export const padGameSeason = (season: string): string => {
  const trailing = parseInt((season as string).slice(2, 4), 10) + 1;
  return `${season}-${trailing}`;
};

export const clnGameSeason = (season: string): string => season.includes('-') ? season.split('-')[0] : season;

export const isHockey = (sport: string) => HockeySports.includes(sport);
export const isSoccer = (sport: string) => SoccerSports.includes(sport);
export const isSoftball = (sport: string) => Sport.Softball === sport;
export const isFootball = (sport: string) => Sport.Football === sport;
export const isLacrosse = (sport: string) => LacrosseSports.includes(sport);

export const canUploadNewGame = (sport: string) => (isHockey(sport) || isSoftball(sport) || isSoccer(sport) || isLacrosse(sport));
export const useCalendarSplit = (sport: string) => (isHockey(sport) || isSoftball(sport) || isSoccer(sport));
export const newerCalendersFirst = (sport: string) => (isHockey(sport) || isSoftball(sport) || isSoccer(sport) || isLacrosse(sport));
export const canUploadAdditionalAttachments = (sport: string) => isLacrosse(sport);
export const hideSubscriptions = (sport: string) => isLacrosse(sport);
export const hideExchangeFile = (sport: string) => isLacrosse(sport);
